module.exports = __webpack_public_path__ + "img/image_2.34bed4ba.svg";